/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthly_Payment_DescriptionInputs */

const en_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly payment`)
};

const id_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran bulanan`)
};

const ms_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayaran bulanan`)
};

const ca_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagament mensual`)
};

const cs_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Měsíční platba`)
};

const da_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlig betaling`)
};

const de_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliche Zahlung`)
};

const et_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuumakse`)
};

const es_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago mensual`)
};

const fr_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement mensuel`)
};

const hr_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mjesečno plaćanje`)
};

const it_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento mensile`)
};

const lv_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikmēneša maksājums`)
};

const lt_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mėnesinis mokėjimas`)
};

const hu_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havi fizetés`)
};

const nl_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijkse betaling`)
};

const nb_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månedlig betaling`)
};

const pl_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatność miesięczna`)
};

const pt_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento mensal`)
};

const ro_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plată lunară`)
};

const sk_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesačná platba`)
};

const sl_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesečno plačilo`)
};

const fi_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuukausimaksu`)
};

const sv_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Månadsbetalning`)
};

const vi_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán hằng tháng`)
};

const tr_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık ödeme`)
};

const el_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μηνιαία πληρωμή`)
};

const bg_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месечно плащане`)
};

const ru_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячный платеж`)
};

const sr_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Месечно плаћање`)
};

const uk_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щомісячний платіж`)
};

const ka_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თვიური გადახდა`)
};

const hi_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मंथली पेमेंट`)
};

const th_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การชำระเงินรายเดือน`)
};

const ko_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월간 결제`)
};

const zh_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按月支付`)
};

const zh_tw_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月付款`)
};

const ja_monthly_payment_description = /** @type {(inputs: Monthly_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月々の支払額`)
};

/**
* | output |
* | --- |
* | "Monthly payment" |
*
* @param {Monthly_Payment_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const monthly_payment_description = /** @type {((inputs?: Monthly_Payment_DescriptionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_Payment_DescriptionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_monthly_payment_description(inputs)
	if (locale === "ms") return ms_monthly_payment_description(inputs)
	if (locale === "ca") return ca_monthly_payment_description(inputs)
	if (locale === "cs") return cs_monthly_payment_description(inputs)
	if (locale === "da") return da_monthly_payment_description(inputs)
	if (locale === "de") return de_monthly_payment_description(inputs)
	if (locale === "et") return et_monthly_payment_description(inputs)
	if (locale === "es") return es_monthly_payment_description(inputs)
	if (locale === "fr") return fr_monthly_payment_description(inputs)
	if (locale === "hr") return hr_monthly_payment_description(inputs)
	if (locale === "it") return it_monthly_payment_description(inputs)
	if (locale === "lv") return lv_monthly_payment_description(inputs)
	if (locale === "lt") return lt_monthly_payment_description(inputs)
	if (locale === "hu") return hu_monthly_payment_description(inputs)
	if (locale === "nl") return nl_monthly_payment_description(inputs)
	if (locale === "nb") return nb_monthly_payment_description(inputs)
	if (locale === "pl") return pl_monthly_payment_description(inputs)
	if (locale === "pt") return pt_monthly_payment_description(inputs)
	if (locale === "ro") return ro_monthly_payment_description(inputs)
	if (locale === "sk") return sk_monthly_payment_description(inputs)
	if (locale === "sl") return sl_monthly_payment_description(inputs)
	if (locale === "fi") return fi_monthly_payment_description(inputs)
	if (locale === "sv") return sv_monthly_payment_description(inputs)
	if (locale === "vi") return vi_monthly_payment_description(inputs)
	if (locale === "tr") return tr_monthly_payment_description(inputs)
	if (locale === "el") return el_monthly_payment_description(inputs)
	if (locale === "bg") return bg_monthly_payment_description(inputs)
	if (locale === "ru") return ru_monthly_payment_description(inputs)
	if (locale === "sr") return sr_monthly_payment_description(inputs)
	if (locale === "uk") return uk_monthly_payment_description(inputs)
	if (locale === "ka") return ka_monthly_payment_description(inputs)
	if (locale === "hi") return hi_monthly_payment_description(inputs)
	if (locale === "th") return th_monthly_payment_description(inputs)
	if (locale === "ko") return ko_monthly_payment_description(inputs)
	if (locale === "zh") return zh_monthly_payment_description(inputs)
	if (locale === "zh-tw") return zh_tw_monthly_payment_description(inputs)
	if (locale === "ja") return ja_monthly_payment_description(inputs)
	return en_monthly_payment_description(inputs)
});